'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import OverviewStatusRow from '~/components/progress/OverviewStatusRow';
import UnitObjectiveProgress from '~/components/progress/UnitObjectiveProgress';
import UnitOverviewDoneTime from '~/components/progress/UnitOverviewDoneTime';
import { CourseUnit } from '~/payload-types';
import { SupportedLocales } from '~/types';
export default function UnitOverviewHeader(t0) {
  const $ = _c(29);
  const {
    linkDisabled,
    modulePath,
    unit,
    number,
    moduleNumber
  } = t0;
  const t = useTranslations();
  const params = useParams();
  let t1;
  if ($[0] !== modulePath) {
    t1 = modulePath.split("/").pop() || "";
    $[0] = modulePath;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const moduleId = t1;
  const t2 = `${moduleNumber}.${number}`;
  let t3;
  if ($[2] !== t || $[3] !== t2) {
    t3 = t("unit.unitN", {
      number: t2
    });
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="min-w-0 pl-3 text-left text-sm sm:pl-5 sm:text-base">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== moduleId || $[8] !== params.courseId || $[9] !== params.locale || $[10] !== unit.id) {
    t5 = <UnitObjectiveProgress courseId={params.courseId} moduleId={moduleId} unitId={unit.id} locale={params.locale} />;
    $[7] = moduleId;
    $[8] = params.courseId;
    $[9] = params.locale;
    $[10] = unit.id;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== params.courseId || $[13] !== params.locale || $[14] !== unit.id || $[15] !== unit.time) {
    t6 = <UnitOverviewDoneTime courseId={params.courseId} unitId={unit.id} locale={params.locale} totalMinutes={unit.time} />;
    $[12] = params.courseId;
    $[13] = params.locale;
    $[14] = unit.id;
    $[15] = unit.time;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <OverviewStatusRow className="w-[12.5rem] justify-end self-center sm:justify-start" objective={t5} time={t6} />;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== linkDisabled || $[21] !== modulePath || $[22] !== unit.id || $[23] !== unit.title) {
    t8 = <div className="col-span-2 min-w-0 pl-3 sm:pl-5">{linkDisabled ? <div className="break-words text-left text-[15px] leading-snug font-bold text-primary sm:text-[17px]">{unit.title}</div> : <Link href={`${modulePath}/unit/${unit.id}`} className="hover:text-primary/50 break-words text-left text-[15px] leading-snug font-bold text-primary sm:text-[17px]">{unit.title}</Link>}</div>;
    $[20] = linkDisabled;
    $[21] = modulePath;
    $[22] = unit.id;
    $[23] = unit.title;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t4 || $[26] !== t7 || $[27] !== t8) {
    t9 = <div className="grid w-full grid-cols-[minmax(0,1fr)_12.5rem] gap-x-3 gap-y-1">{t4}{t7}{t8}</div>;
    $[25] = t4;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}